import { MenuItem } from "@mui/material";
import Swal from "sweetalert2";
import { editProjectDetails } from "../../apis/apiService";
import { CiEdit } from "react-icons/ci";

const CommonTaskIssueNameChamge = ({
  name,
  path,
  setMenuAnchorEl,
  selectedTask,
  refetch_list,
  isModule,
}) => {
  if (!selectedTask) return null;
  const { name: selected_name, title, id, task_id } = selectedTask;
  // console.log("selectedTask :", selectedTask);
  const handleUpdateProjectName = () => {
    setMenuAnchorEl(null);

    Swal.fire({
      title: `Update ${name} Name`,
      input: "textarea",
      // inputLabel: "Project Name",
      inputValue: selected_name ? selected_name : title,
      inputPlaceholder: `Enter new ${name} name...`,
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Update it!",
      showCloseButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
      showClass: {
        popup: "animate__animated animate__fadeInLeft",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },

      inputValidator: (value) => {
        if (!value.trim()) {
          return "Name cannot be empty!";
        }
      },

      preConfirm: async (newTitle) => {
        try {
          const response = await editProjectDetails(
            path,
            isModule ? task_id : id,
            {
              title: newTitle,
            }
          );
          if (response) {
            refetch_list();
            Swal.fire({
              title: "Updated!",
              text: `${name} name updated successfully!`,
              icon: "success",
              confirmButtonText: "OK",
              customClass: {
                popup: "custom-swal-popup",
                confirmButton: "swal-confirm-btn",
                title: "custom-swal-title",
                text: "custom-swal-html",
                icon: "custom-swal-icon",
              },
            });
          }
        } 
        catch (error) {
          Swal.fire("Error", error.message || "Something went wrong", "error");
        }
      },
    });
  };

  return (
    <div>
      <MenuItem onClick={handleUpdateProjectName}>
        {" "}
        <CiEdit className="me-2" color="blue" />
        Change {name} Name{" "}
      </MenuItem>
    </div>
  );
};

export default CommonTaskIssueNameChamge;
